// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    appStoreUrl: 'https://apps.apple.com/se/app/safetly-hyr-hitta-jobb/id1469027969',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.justraspberry.safetly',
    googleClientId: '526845199010-gcqtpth23g1vsgnsla81epjg2a1b2g09.apps.googleusercontent.com',
    stripePublishableKey: 'pk_test_51SXj5mK87B7E7JFO9MItzMiHgqOWosdAYtZ0NxpR5W9IpjTFge1pVr0WjGraSwBwEsUTPIAaNRvumVfH2LiuIDoQ00Y9lskks7',
    apiUrl: 'https://api.safetly.se/api',
    appUrl: 'https://app.safetly.se',
    googleMapApiKey: 'AIzaSyCKm_wNklUrHWRv9nINRo0uzU8V2nF4t-Y',
    // Pusher configuration
    pusher: {
        key: 'c32cdc7a5def3b2741f0',
        cluster: 'eu',
        useTLS: false,
    },
    sentryDsn: "https://9245d21bc989b038fd07de0891a4728d@o4510777967116288.ingest.de.sentry.io/4510777971769424",
    firebase: {
        // apiKey: "AIzaSyBjMQ_FZmMUwjZNg_N6FSw7Kd2TpaBGyGs",
        // authDomain: "safetly-v2.firebaseapp.com",
        // projectId: "safetly-v2",
        // storageBucket: "safetly-v2.appspot.com",
        // messagingSenderId: "529691811975",
        // appId: "1:529691811975:web:5d0e0d9b1bbb585c5d5822",
        // measurementId: "G-CXHLBJM9ME"
        // apiKey: "AIzaSyDyZMH14lUfn95sof7Cpp_mgftqgICO8qc",
        apiKey: "AIzaSyCKm_wNklUrHWRv9nINRo0uzU8V2nF4t-Y",
        // authDomain: "safetly-app.firebaseapp.com",
        authDomain: "safetly-c5bbb.firebaseapp.com",
        // projectId: "safetly-app",
        projectId: "safetly-c5bbb",
        // storageBucket: "safetly-app.appspot.com",
        storageBucket: "safetly-c5bbb.appspot.com",
        // messagingSenderId: "1234567890",
        messagingSenderId: "526845199010",
        // appId: "1:1234567890:web:1234567890",
        appId: "1:526845199010:web:e4a3f52a7f1352e1308dfb",
        measurementId: "G-CXHLBJM9ME",
    },
    msalConfig: {
        auth: {
            clientId: '7778c491-4e6d-41fa-bfa0-95326f8f552b',
            authority: 'https://login.microsoftonline.com/common',
            redirectUri: 'https://app.safetly.se'
        }
    },
    posthog: {
        key: 'phc_gqSM1EPItwinuYRl4vp6up7tcq1hkzbBsAeVddK0hNc',
        host: 'https://eu.i.posthog.com'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.